import { useLogoutListener } from '@/features/Listeners/hooks/useLogoutListener';
import { useTokenExpiry } from '@/hooks/useTokenExpiry';

const Listeners = () => {
  useTokenExpiry();
  useLogoutListener();
  return null;
};

export default Listeners;
